import type { FaireProductEntity } from "../../entity_types/product";

export const p_t7g6vfr45f: FaireProductEntity = {
  token: "p_t7g6vfr45f",
  type: "product",
  name: "Mommy and Me Matching Beanies [Kids]",
  brandToken: "b_gy33y47y5m",
  brandName: "Fashion City",
  imageUrl:
    "https://cdn.faire.com/fastly/b67713086a219d42084d22f264169f72c03c0084c7da9beb8bd9b6ed5fb74fbf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1497a628600117b5f86b98b944631876b6cd2940b0ea3d7762c27164a90d555e.jpeg",
    "https://cdn.faire.com/fastly/5805dfba2b9376cba76fccdb564ce7fbcff7f272bfde78e394081bbf34c07d24.jpeg",
    "https://cdn.faire.com/fastly/276ba01ece9252ec93f7d0bb51a6735ea34da4bbf91a4252133adc86e503d22c.jpeg",
    "https://cdn.faire.com/fastly/e6ab967e70bd22725d08505a52e433f8283f7ff36c3cfb33594b1fbaa597d779.jpeg",
    "https://cdn.faire.com/fastly/a86558d1cec909bf22879affc8ea2782425b4f0ea1feb80d01e035c767b725f7.jpeg",
    "https://cdn.faire.com/fastly/6341a8d4ed14706316619e59058e60c59b5720e85bdb6f1dd4116c059cffe460.jpeg",
    "https://cdn.faire.com/fastly/c43dc2e0a2bdd99b86c6d068e1739e4f18d52d285875e790a0de6062e596d1e2.jpeg",
    "https://cdn.faire.com/fastly/4bbc27e6462fa1d4932139c4939ea639d43e9aff1605ee9d659c077c6b69350c.jpeg",
    "https://cdn.faire.com/fastly/4a9c5e2aa388112fe679c90bc02fb7406a608151ab809fdab13d86a4159ed2af.jpeg",
    "https://cdn.faire.com/fastly/0a2a841d5015632da06678e481a6c5846355ce109ccc71038409276a528f01d7.jpeg",
  ],
  priceDollars: 34.57,
  description:
    " Mommy and Me Matching Beanies [Kids] \n\n***Comes with 1 Adult Beanie+1 Kids Beanie***\n- Criss Cross Knitted Design\n- Faux Fur Pom-Pom Attached\n- 47% Rayon, 31% PBT, 22% Nylon\n- Kids Hat (For 1 to 4 years old)\n",
  tags: [],
  msrpDollars: 103.72,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:09.030Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
